(function () {
    "use strict";

    var STORAGE_KEY = "rtpCompletedLessons";
    var LAST_LESSON_KEY = "rtpLastLesson";
    var TOTAL_LESSONS = 42;

    function getCompletedLessons() {
        try {
            var stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");

            return Array.isArray(stored)
                ? stored.filter(function (item) {
                    return typeof item === "string";
                })
                : [];
        } catch (error) {
            return [];
        }
    }

    function saveCompletedLessons(lessons) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(lessons)));
    }

    function initialiseLessonButton() {
        var button = document.querySelector("[data-rtp-complete]");

        if (!button) {
            return;
        }

        var lessonSlug = button.getAttribute("data-lesson-slug");
        var status = document.querySelector("[data-rtp-complete-status]");
        var completed = new Set(getCompletedLessons());

        if (!lessonSlug) {
            return;
        }

        localStorage.setItem(LAST_LESSON_KEY, window.location.pathname);

        function renderButton() {
            var isComplete = completed.has(lessonSlug);

            button.classList.toggle("is-complete", isComplete);
            button.setAttribute("aria-pressed", String(isComplete));

            button.textContent = isComplete
                ? "Lesson complete — click to undo"
                : "Mark this lesson as complete";

            if (status) {
                status.textContent = isComplete
                    ? "This lesson is marked complete on this device."
                    : "";
            }
        }

        button.addEventListener("click", function () {
            if (completed.has(lessonSlug)) {
                completed.delete(lessonSlug);
            } else {
                completed.add(lessonSlug);
            }

            saveCompletedLessons(completed);
            renderButton();
        });

        renderButton();
    }

    function initialiseDashboardProgress() {
        var progressBar = document.querySelector("[data-rtp-progress-bar]");

        if (!progressBar) {
            return;
        }

        var completed = new Set(getCompletedLessons());
        var completedCount = Math.min(completed.size, TOTAL_LESSONS);
        var percentage = Math.round((completedCount / TOTAL_LESSONS) * 100);

        var heading = document.querySelector("[data-rtp-progress-heading]");
        var percentageText = document.querySelector("[data-rtp-progress-percent]");
        var continueButton = document.querySelector("[data-rtp-continue]");
        var lastLesson = localStorage.getItem(LAST_LESSON_KEY);

        progressBar.style.width = percentage + "%";

        if (heading) {
            heading.textContent =
                completedCount + " of " + TOTAL_LESSONS + " lessons complete";
        }

        if (percentageText) {
            percentageText.textContent = percentage + "% complete";
        }

        if (continueButton && lastLesson && lastLesson.charAt(0) === "/") {
            continueButton.setAttribute("href", lastLesson);
        }
    }

    document.addEventListener("DOMContentLoaded", function () {
        initialiseLessonButton();
        initialiseDashboardProgress();
    });
})();
